import { InputCopy } from '@tribeplatform/react-ui-kit/Input'

import { T } from '../i18n/index.js'

export const ShareInviteMemberLink = ({ url }) => {
  return (
    <>
      <div className="text-content">
        <T defaultMessage="Share invite link" id="UserImport.ShareLink" />
      </div>
      <div className="text-sm mb-2 text-content-subdued">
        <T
          defaultMessage="Anyone with this link can join as a member."
          id="UserImport.ShareLink.Description"
        />
      </div>
      <InputCopy value={url} readOnly />
    </>
  )
}
